
import {IServiceFilterOut} from "cdp-fe-commons-layout";

export class catalogoApi {
    public static GET_ALL_ALLEGATI_BY_CATALOGO_ID(catalogoId: string): string {
        return `/catalogo-allegati/findAllByCatalogoIdAndDataFineIsNull?catalogoId=${catalogoId}`;
    }

    public static GET_ALL_ARGOMENTI(): string {
        return `/argomento`
    }

    public static GET_ALL_MATERIE(): string {
        return `/materie`
    }

    public static GET_ALL_STRUTTURE(): string {
        return `/catalogo/strutture`
    }

    public static GET_ALL_ARGOMENTI_BY_MATERIA_ID(materiaId: number | string): string {
        return `/argomento/search/findAllByMaterieId?materieId=` + materiaId;
    }

    public static GET_ALL_DESTINATARI(): string {
        return `/destinatario`
    }

    public static GET_DESTINATARI_BY_CATALOGO_ID(): string {
        return `/catalogoDestinatari/search/findAllByCatalogoId`
    }

    public static GET_ALL_TIPOLOGIE(): string {
        return `/tipologia`
    }

    public static GET_ALL_CATALOGO_ISTANZE(page: number, limit: number, filters?: IServiceFilterOut): string {
        let url = `/catalogoIstanze/search/getActiveCatalogosWithFilters?page=${(page - 1)}&size=${limit}`
        url += `&testo=${filters?.text ?? ''}`;
        url += filters?.destinatari && filters.destinatari.length > 0 ? `&destinatari=${filters.destinatari.join(",")}` : ''
        url += filters?.argomento ? `&argomenti=${filters.argomento}` : ''
        url += filters?.materia ? `&materie=${filters.materia}` : ''
        url += filters?.tipologia ? `&tipologie=${filters.tipologia}` : ''
        url += filters?.tipologieProcedimento ? `&codiceTipologiaProcedimento=${filters.tipologieProcedimento.join(",")}` : ''
        return url;
    }

    public static GET_ALL_CATALOGO_ISTANZE_INTERNI(page: number, limit: number, filters?: IServiceFilterOut): string {
        let url = `/catalogoIstanze/search/getActiveCatalogosInterni?page=${(page - 1)}&size=${limit}`
        url += `&testo=${filters?.text ?? ''}`;
        url += filters?.tipologieProcedimento ? `&codiceTipologiaProcedimento=${filters.tipologieProcedimento.join(",")}` : ''
        url += filters?.username ? `&username=${filters.username}` : ''
        url += filters?.utenteId ? `&utenteId=${filters.utenteId}` : ''
        return url;
    }

    public static GET_CATALOGO_ISTANZE_BY_CODICE(codiceCatalogo: string): string {
        return `/catalogoIstanze/search/getFirstByCodiceCdp?codice=${codiceCatalogo}`
    }

    public static GET_CAMPAGNA_LIST_BY_CATALOGO(catalogoId: string, utenteId?: string, username?: string): string {
        const params = [];
        if (utenteId) {
            params.push(`utenteId=${utenteId}`);
        }
        if (username) {
            params.push(`username=${username}`);
        }

        let url = `/ws/catalogo/${catalogoId}/getCampagnaListByCatalogo`;
        if (params.length > 0) {
            url += `?${params.join('&')}`;
        }
        return url;
    }

    public static GET_TITOLO_CATALOGO_ISTANZE_BY_CODICE_CATALOGO(codiceCatalogo: string): string {
        return `/catalogoIstanze/search/getFirstTitoloCatalogoByCodiceCdp?codice=${codiceCatalogo}`
    }

    public static FIND_BY_ID(catalogoId: string | number): string {
        return `/catalogoIstanze/${catalogoId}`
    }

    public static GET_ALL_MODULISTICA_BY_CAMPAGNA_IDS(campagnaIds: number[]): string {
        return `/campagna-modulistica/findAllByCampagnaIds?campagnaIds=${campagnaIds.join(",")}`
    }

    public static DOWNLOAD_MODULISTICA_BY_CAMPAGNA_IDS(campagnaIds: number[]): string {
        return `/catalogo/modulistica/zip?campagnaIds=${campagnaIds.join(",")}`;
    }

    public static GET_ALLEGATO_INTEGRAZIONE(catalogoid: string, key: string): [string, any] {
        return [`/catalogo/allegati/integrazione`, {catalogoid: catalogoid, key: key}];
    }

    public static GET_ALLEGATO_ESENZIONE_PAGAMENTO(catalogoid: string, key: string, descrizione: string): [string, any]
    {
        return [`/catalogo/allegati/pagamenti/esenzione`, {catalogoId: catalogoid, key: key, descrizione: descrizione}];
    }

    public static GET_ALL_PAGAMENTI_BY_CAMPAGNA_ID(campagnaId: string){
        return `/campagna-pagamenti/findAllActiveByCampagnaId?campagnaId=${campagnaId}`
    }

    public static EXISTS_PAGAMENTI_BY_CAMPAGNA_ID(campagnaId: string){
        return `/campagna-pagamenti/existsActiveByCampagnaId?campagnaId=${campagnaId}`
    }

    // Banner
    public static FIND_LAST_VALID_MESSAGGIO() {
        return `/banner`;
    }
}
